export default "__VITE_ASSET__l41gNHnL__"